import { render, staticRenderFns } from "./local-case-types-grid.vue?vue&type=template&id=c36dceba&scoped=true&"
import script from "./local-case-types-grid.ts?vue&type=script&lang=ts&"
export * from "./local-case-types-grid.ts?vue&type=script&lang=ts&"
import style0 from "./local-case-types-grid.scss?vue&type=style&index=0&id=c36dceba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36dceba",
  null
  
)

export default component.exports